// 🟦 PrivateRoute.jsx
// This file checks if a user is logged in before allowing access to a page.

import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../store/useAuthStore";
import { logger } from "../../utils/logger";

logger.log("📂 [PrivateRoute.jsx] File started");

const PrivateRoute = ({ children }) => {
  logger.log("➡️ [PrivateRoute] Function start - checking authentication");

  const isAuthed = useAuthStore((s) => s.isAuthenticated());

  if (!isAuthed) {
    logger.warn("⚠️ [PrivateRoute] User not authenticated - redirecting to Signin");
    logger.log("⬅️ [PrivateRoute] Function end - redirecting");
    return <Navigate to="/signin" replace />;
  }

  logger.log("✅ [PrivateRoute] User authenticated - access granted");
  logger.log("⬅️ [PrivateRoute] Function end - rendering child page");
  return children;
};

logger.log("✅ [PrivateRoute.jsx] File executed successfully");
export default PrivateRoute;
